export {
  default as NewPermission,
  type TNewPermissionProps,
  type TApproachOfIdentityToShare,
} from './NewPermission';
export { default as PermissionListItem, type TPermissionListItemProps } from './PermissionListItem';
export { default as PermissionList, type TPermissionListProps } from './PermissionList';
